import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_mst_item_hdr_Rowinterface {
    guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    code_alias_json: fromDatatype.JsonDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    price_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.VarcharDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
    txn_class: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    ccy_xrate: fromDatatype.NumericDatatypeInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
    sub_item_type: fromDatatype.VarcharDatatypeInterface;
    coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    emp_status: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    dim_width: fromDatatype.NumericDatatypeInterface;
    dim_height: fromDatatype.NumericDatatypeInterface;
    dim_length: fromDatatype.NumericDatatypeInterface;
    dim_weight: fromDatatype.NumericDatatypeInterface;
    consignment_flg: boolean;
    tax_country: fromDatatype.VarcharDatatypeInterface;
    input_tax_type: fromDatatype.VarcharDatatypeInterface;
    input_tax_code: fromDatatype.VarcharDatatypeInterface;
    input_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_tax_type: fromDatatype.VarcharDatatypeInterface;
    output_tax_code: fromDatatype.VarcharDatatypeInterface;
    output_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
    output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
    output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
    tax_applicable: boolean;
    sort_code: fromDatatype.VarcharDatatypeInterface;
    product_ranking: fromDatatype.IntegerDatatypeInterface;
    cfg_production: fromDatatype.VarcharDatatypeInterface;
    cfg_delivery: fromDatatype.VarcharDatatypeInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    seo_schema_json: fromDatatype.JsonDatatypeInterface;
    cfg_preorder: fromDatatype.VarcharDatatypeInterface;
    membership_class_guid: fromDatatype.GuidDataFieldInterface;
    extended_warranty_years: fromDatatype.IntegerDatatypeInterface;
    title_writer: fromDatatype.VarcharDatatypeInterface;
    meta_desc: fromDatatype.VarcharDatatypeInterface;
    scheme_generator: fromDatatype.JsonDatatypeInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    main_image_guid: fromDatatype.GuidDataFieldInterface;
    input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
    input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
    input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
    pricing_logic: fromDatatype.VarcharDatatypeInterface;
    valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
    valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
    label_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
    sales_contract_template_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_11_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    marketplace_product_publishing_status: fromDatatype.VarcharDatatypeInterface;
    cfg_tracking_inventory: fromDatatype.VarcharDatatypeInterface;
    posting_branch_guid: fromDatatype.GuidDataFieldInterface;
    posting_mkt_type: fromDatatype.VarcharDatatypeInterface;
    posting_logic: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mkp_mst_item_hdr_Rowclass implements bl_mkp_mst_item_hdr_Rowinterface {
    guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    code_alias_json: fromDatatype.JsonDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    price_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.VarcharDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
    txn_class: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    ccy_xrate: fromDatatype.NumericDatatypeInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
    sub_item_type: fromDatatype.VarcharDatatypeInterface;
    coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    emp_status: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    dim_width: fromDatatype.NumericDatatypeInterface;
    dim_height: fromDatatype.NumericDatatypeInterface;
    dim_length: fromDatatype.NumericDatatypeInterface;
    dim_weight: fromDatatype.NumericDatatypeInterface;
    consignment_flg: boolean;
    tax_country: fromDatatype.VarcharDatatypeInterface;
    input_tax_type: fromDatatype.VarcharDatatypeInterface;
    input_tax_code: fromDatatype.VarcharDatatypeInterface;
    input_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_tax_type: fromDatatype.VarcharDatatypeInterface;
    output_tax_code: fromDatatype.VarcharDatatypeInterface;
    output_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
    output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
    output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
    tax_applicable: boolean;
    sort_code: fromDatatype.VarcharDatatypeInterface;
    product_ranking: fromDatatype.IntegerDatatypeInterface;
    cfg_production: fromDatatype.VarcharDatatypeInterface;
    cfg_delivery: fromDatatype.VarcharDatatypeInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    seo_schema_json: fromDatatype.JsonDatatypeInterface;
    cfg_preorder: fromDatatype.VarcharDatatypeInterface;
    membership_class_guid: fromDatatype.GuidDataFieldInterface;
    extended_warranty_years: fromDatatype.IntegerDatatypeInterface;
    title_writer: fromDatatype.VarcharDatatypeInterface;
    meta_desc: fromDatatype.VarcharDatatypeInterface;
    scheme_generator: fromDatatype.JsonDatatypeInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    main_image_guid: fromDatatype.GuidDataFieldInterface;
    input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
    input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
    input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
    pricing_logic: fromDatatype.VarcharDatatypeInterface;
    valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
    valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
    label_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
    sales_contract_template_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_11_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    marketplace_product_publishing_status: fromDatatype.VarcharDatatypeInterface;
    cfg_tracking_inventory: fromDatatype.VarcharDatatypeInterface;
    posting_branch_guid: fromDatatype.GuidDataFieldInterface;
    posting_mkt_type: fromDatatype.VarcharDatatypeInterface;
    posting_logic: fromDatatype.VarcharDatatypeInterface;
}